import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Sparkles, Truck } from "lucide-react";
import { OFFERS } from "../config/offers";

// Rotating festive / standing offers strip pinned to the very top of the page.
export const OffersBanner = () => {
  const [i, setI] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setI((n) => (n + 1) % OFFERS.length), 4200);
    return () => clearInterval(id);
  }, []);
  const o = OFFERS[i];
  const Icon = o.id === "delivery" ? Truck : Sparkles;
  return (
    <div
      data-testid="offers-announcement-bar"
      className="bg-gold text-charcoal relative z-50 overflow-hidden"
      role="status"
      aria-live="polite"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-9 sm:h-10 flex items-center justify-center">
        <AnimatePresence mode="wait" initial={false}>
          <motion.p
            key={o.id}
            data-testid={`offer-${o.id}`}
            initial={{ y: 14, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: -14, opacity: 0 }}
            transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
            className="flex items-center gap-2 sm:gap-3 font-mono text-[10px] sm:text-xs font-medium tracking-[0.14em] uppercase text-center"
          >
            <Icon size={14} strokeWidth={2.4} className="shrink-0" />
            <span className="hidden sm:inline rounded-full bg-charcoal text-gold px-2.5 py-0.5 text-[9px] tracking-[0.2em]">
              {o.tag}
            </span>
            <span>{o.text}</span>
          </motion.p>
        </AnimatePresence>
      </div>
      <div className="absolute bottom-0 left-0 h-0.5 bg-charcoal/25 w-full" aria-hidden="true">
        <motion.div
          key={o.id}
          className="h-full bg-charcoal/60"
          initial={{ width: "0%" }}
          animate={{ width: "100%" }}
          transition={{ duration: 4.2, ease: "linear" }}
        />
      </div>
    </div>
  );
};
